(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["photo-gallery"] && !window.DesignMode) return;
  try {
    

// init Isotope
var iso = new Isotope( '.grid-masonry', {
  itemSelector: '.grid-item',
  percentPosition: true,
  gutter: 0,
  masonry: {
    columnWidth: '.grid-sizer',
    gutter: 0
  }
});

// filter functions
var filterFns = {
  // show if number is greater than 50
  numberGreaterThan50: function( itemElem ) {
    var number = itemElem.querySelector('.number').textContent;
    return parseInt( number, 10 ) > 50;
  },
  // show if name ends with -ium
  ium: function( itemElem ) {
    var name = itemElem.querySelector('.name').textContent;
    return name.match( /ium$/ );
  }
};

// bind filter button click
var filtersElem = document.querySelector('.filters-button-group');
filtersElem.addEventListener( 'click', function( event ) {
  // only work with buttons
  if ( !matchesSelector( event.target, 'button' ) ) {
    return;
  }
  var filterValue = event.target.getAttribute('data-filter');
  // use matching filter function
  filterValue = filterFns[ filterValue ] || filterValue;
  iso.arrange({ filter: filterValue });
});

// change is-checked class on buttons
var buttonGroups = document.querySelectorAll('.button-group');
for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
  var buttonGroup = buttonGroups[i];
  radioButtonGroup( buttonGroup );
}

function radioButtonGroup( buttonGroup ) {
  buttonGroup.addEventListener( 'click', function( event ) {
    // only work with buttons
    if ( !matchesSelector( event.target, 'button' ) ) {
      return;
    }
    buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
    event.target.classList.add('is-checked');
  });
}


  (function(){
    const images = document.querySelectorAll('.mw-image-gallery a');
    const modal = document.querySelector('.mw-modal');
    const modalImage = modal.querySelector('img');
    let currentIndex = 0;
    
    // Open modal popup and show clicked image
    function showModal(index) {
      if(window.innerWidth > 749){
        modalImage.src = images[index].dataset.desktop;
      } else {
        modalImage.src = images[index].dataset.mobile;  
      }    
      modal.classList.add('show');
      currentIndex = index;
    }
    
    // Hide modal popup
    function hideModal() {
      modal.classList.remove('show');
    }
    
    // Show previous image in gallery
    function showPrevImage(e) {
      e.stopPropagation()
      if (currentIndex === 0) {
        showModal(images.length - 1);
      } else {
        showModal(currentIndex - 1);
      }
    }
    
    // Show next image in gallery
    function showNextImage(e) {
      e.stopPropagation()
      if (currentIndex === images.length - 1) {
        showModal(0);
      } else {
        showModal(currentIndex + 1);
      }
    }
    
    // Add click event listeners to all images
    images.forEach((image, index) => {
      image.addEventListener('click', (e) => {
        e.preventDefault()
        showModal(index);
      });
    });  
      
    // Add click event listeners to modal navigation arrows
    const prevArrow = modal.querySelector('.mw-modal-prev');
    prevArrow.addEventListener('click', showPrevImage);
    
    const nextArrow = modal.querySelector('.mw-modal-next');
    nextArrow.addEventListener('click', showNextImage);
    
    // Add click event listener to modal background to hide it
    modal.addEventListener('click', hideModal);
  
    
  })()
  
  } catch(e) { console.error(e); }
})();
})();
